<h1 class="middle">{{'PASSENGERS_TERMS_AND_CONDITIONS' | resource}}</h1>
<div class="row">
    <div class="column small-12 field">
        <sbw-checkbox (checkedChange)="changedEvent($event)">
            <span [innerHTML]="linkText"></span>
            <a [attr.href]="model.termsAndConditionsLink" target="_blank">{{termsAndConditionsText}}</a>
        </sbw-checkbox>
    </div>
    <div class="column small-12">
        <div *ngIf="control.invalid && control.dirty">
            <span class="field-validation-error">{{ 'VALIDATION_TERMS_AND_CONDITIONS' | resource }}</span>
        </div>
    </div>
</div>